import React, { FC } from "react";
import { SvgIconProps } from "./SvgIcon.props";

const SvgIcon: FC<SvgIconProps> = ({
	Icon,
	className = "",
	width = 24,
	height = 24,
	...props
}) => {
	return (
		<Icon width={width} height={height} className={`${className}`} {...props} />
	);
};

export default SvgIcon;
